<template>
  <div name="hres81x-search-box-index" class="hres81x-search-box-index clearfix">
    <div :class="[searchboxDisp == true ? 'search-group-wrapper' : 'search-group-wrapper-min']">
      <div ref="searchboxWrapper" class="toggle-wrapper clearfix" @click="toggleSearchboxDisp()">
          <div class="search-ico"><i class="fa fa-search"></i></div>
          <div class="search-label" v-show="searchboxDisp"> {{ dash.button[dash.nowLang].search }} </div>
          <div class="close-ico" v-show="searchboxDisp"><i class="fa fa-times"></i></div>
      </div>
      <div ref="searchboxPanel" class="search-box-panel clearfix" v-show="searchboxDisp">
        <hrms-search-box
                  v-model="searchIndex"
                  :receivedStore="receivedStore"
                  :nowLang="nowLang"
                  :searchBoxAlias="searchBoxAlias"
                  @setLoadingParentBool="loadingParentBool = arguments[0]" />
      </div>
    </div>

    <div ref="table" class="clearfix" :class="[searchboxDisp == true ? 'table-box-wrapper' : 'table-box-wrapper-full']">
      <index  :currentUser="currentUser"
              :nowLang="nowLang"
              :labels="labels"
              :labelsHres81x="labelsHres81x"
              :msgError="data.msg_error"
              :blockIndex="data.block_index"
              :block="data.block"
              :block1="data.block1"
              :block2="data.block2"
              :block3="data.block3"
              :baseUrl="baseUrl"
              :searchIndex="searchIndex"
              :postHres81xPrint="postHres81xPrint"
              :flgProcess="flgProcess" />
    </div> 
  </div>
</template>

<script>
import bus from 'assets/js/bus'
import index from 'components/hres81x/index'
import moment from 'moment'
import env from 'src/../env.js'
import $ from 'jquery'

export default {
  name: 'hres81x-search-box-index',
  data () {
    return {
      dash: this.$parent.$parent.$parent.$parent,
      loadingParentBool: true,
      searchboxDisp: true,
      searchIndex: {
        period: '1',
        month: moment().format('M'),
        year: moment().format('YYYY')
      },
      baseUrl: window.localStorage.getItem(env.site + '_baseURL')
    }
  },
  created () {
    this.receivedStoreNumPeriod()
  },
  watch: {
    searchIndex () {
      this.receivedStoreNumPeriod()
      this.receivedStore(this.searchIndex)
    },
    'searchIndex.year' () {
      this.receivedStoreNumPeriod()
    },
    'searchIndex.month' () {
      this.receivedStoreNumPeriod()
    },
    lastNumperiod () {
      this.searchIndex.period = this.lastNumperiod
    },
    numperiod () {
      let arrNumperiod = this.numperiod.split(',')
      let htmlOption = '<option value="">Please Selected</option>'
      let periodno
      let descPeriod
      let tmpPeriod
      for (var i in arrNumperiod) {
        tmpPeriod = arrNumperiod[i].split(':')
        periodno = typeof tmpPeriod[0] !== 'undefined' ? tmpPeriod[0] : ''
        descPeriod = typeof tmpPeriod[1] !== 'undefined' ? tmpPeriod[1] : ''
        descPeriod = descPeriod !== '' ? descPeriod : tmpPeriod
        htmlOption += '<option value="' + periodno + '">' + descPeriod + '</option>'
      }
      $('div[data-vv-name=period] select').html(htmlOption)
      this.searchIndex.period = this.lastNumperiod
    }
  },
  methods: {
    toggleSearchboxDisp () {
      this.searchboxDisp = !this.searchboxDisp
    },
    receivedStoreNumPeriod () {
      this.receivedHres81xNumperiod(this.searchIndex)
    }
  },
  mounted () {
    bus.$on('veeValidate', () => {
      this.$validator.validateAll().then(result => {
        this.$emit('validateEvent', result)
      }).catch(result => {
        this.$emit('validateEvent', false)
      })
    })
  },
  props: [ 'receivedStore', 'searchBoxAlias', 'currentUser', 'nowLang', 'labels', 'labelsHres81x', 'data', 'labelsHres81x', 'postHres81xPrint', 'flgProcess', 'lastNumperiod', 'numperiod', 'receivedHres81xNumperiod' ],
  components: {
    index
  }
}
</script>

<style lang="scss">
.hres81x-search-box-index {
  width: 100%;
  background: #FFF;
  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);
  position: relative;

  @media (max-width: 768px) {
    display: block;
  }

  .search-group-wrapper {
    width: 250px;
    position: absolute;
    animation-name: search-resize-max;
    animation-duration: .2s;
    height: 100%;
    background: #F5F5F5;
    min-height: 660px;
    animation-duration: .4s;

    @media (max-width: 768px) {
      width: 100%;
      float: none;
      display: block;
      position: relative;
      min-height: auto;
      animation-name: none;
    }

    .toggle-wrapper {
      width: 100%;
      background: #F5F5F5;
      padding: 8px 15px 5px 13px;
      color: #757575;
      font-size: 18px;
      cursor: pointer;
      border-bottom: 1px solid #d2d6de;

      .search-ico {
        float: left;
      }

      .search-label {
        float: left;
        font-size: 16px;
        font-weight: 700;
        padding: 1px 0 0 5px;
      }

      .close-ico {
        float: right;
      }
    }
  }
  .search-group-wrapper-min {
    width: 45px;
    float: left;

    @media (max-width: 768px) {
      width: 100%;
      float: none;
      display: block;
    }

    .toggle-wrapper {
      width: 100%;
      padding: 8px 15px 5px 13px;
      color: #757575;
      font-size: 18px;
      cursor: pointer;

      .search-ico {
        float: left;
      }

      .search-label {
        float: left;
        font-size: 16px;
        font-weight: 700;
        padding: 1px 0 0 5px;
      }

      .close-ico {
        float: right;
      }
    }
  }

  .search-box-panel {
    // width: 100%;
    // height: auto;
    // background: #F5F5F5;
    // box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.3);
    // min-height: 660px;
    // animation-duration: .4s;

    @media (max-width: 768px) {
      min-height: 0;
      display: block;
    }
  }
  .table-box-wrapper {
    width: 100%;
    padding-left: 250px;
    background: #FFF;
    height: 100%;
    min-height: 660px;

    @media (max-width: 768px) {
      width: 100%;
      padding-left: 0px;
      float: none;
      display: block;
      min-height: 300px;
    }
  }
  .table-box-wrapper-full {
    width: 100%;
    padding-left: 45px;
    background: #FFF;
    height: 100%;
    min-height: 660px;

    @media (max-width: 768px) {
      width: 100%;
      padding-left: 0px;
      float: none;
      display: block;
    }
  }
  .box {
    box-shadow: none;
  }
}

@keyframes search-resize-max {
  0% {
    width: 45px;
  }
  100% {
    width: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// searchBoxIndex.vue?6e4b63bc